import { Box, DialogActions, Typography } from "@mui/material";
import React from "react";
import { useIntl } from "react-intl";
import { Button } from "../buttons";
import { Tag } from "../form-controls";

type SearchHelpDialogActionsProps = {
    onApply: () => void;
    onCancel: () => void;
    tags?: { key: string; text: string }[];
    onDeleteTag?: (key: string) => void;
    getTagText?: (key: string, text: string) => string;
    disabled?: boolean;
    applyTitle?: string;
};

const SearchHelpDialogActions: React.FC<SearchHelpDialogActionsProps> = ({
    tags = [],
    onDeleteTag = () => {},
    onCancel,
    onApply,
    getTagText = (key) => key,
    disabled = false,
    applyTitle,
}) => {
    const intl = useIntl();
    const tagsTitle = intl.formatMessage({ id: "search-help.tag-view.title" });
    const cancelTitle = intl.formatMessage({ id: "common.btn-cancel" });

    return (
        <DialogActions className="search-help-dialog-actions">
            {tags?.length > 0 && (
                <Box className="search-help-dialog-actions-tags-container">
                    <Typography className="search-help-tag-view-title">{tagsTitle}</Typography>

                    <Box className="search-help-dialog-actions-tag-view">
                        {tags?.map(({ key, text }) => <Tag key={key} tag={getTagText(key, text)} onDelete={() => onDeleteTag(key)} size="small" />)}
                    </Box>
                </Box>
            )}

            <Box className="search-help-dialog-actions-buttons">
                <Button
                    variant="outlined"
                    onClick={onCancel}
                    sx={{
                        color: "var(--font-4)",
                        borderColor: "var(--font-4)",
                    }}
                >
                    {cancelTitle}
                </Button>

                <Button
                    variant="contained"
                    onClick={onApply}
                    disabled={disabled}
                    sx={{
                        color: "var(--bg-2)",
                        backgroundColor: "var(--font-2)",
                        "&:hover": {
                            backgroundColor: "var(--font-2)",
                        },
                    }}
                >
                    {applyTitle ?? intl.formatMessage({ id: "common.btn-apply" })}
                </Button>
            </Box>
        </DialogActions>
    );
};

export default SearchHelpDialogActions;
